import { render } from "./resultBox.vue?vue&type=template&id=09328842"
import script from "./resultBox.vue?vue&type=script&lang=js"
export * from "./resultBox.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__